import { createStore } from "@stencil/store";

interface UnreadCountState {
  totalUnreadCount: number;
}

const { state, onChange } = createStore<UnreadCountState>({
  totalUnreadCount: 0
});

export const unreadCountStore = {
  state,
  
  // Update total unread count
  updateTotalUnreadCount(count: number) {
    state.totalUnreadCount = count;
  },

  // Get current unread count
  getTotalUnreadCount() {
    return state.totalUnreadCount;
  },

  // Subscribe to changes
  onChange: onChange
}; 